/**
 * Product and Experiment selector component
 * Allows users to switch between different product/experiment combinations
 */

import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Product, ExperimentVersion } from '../../types';
import { useAppStore } from '../../store/appStore';

export default function ProductExperimentSelector() {
  const selectedProduct = useAppStore((state) => state.selectedProduct);
  const selectedExperiment = useAppStore((state) => state.selectedExperiment);
  const setProduct = useAppStore((state) => state.setProduct);
  const setExperiment = useAppStore((state) => state.setExperiment);

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>Product</InputLabel>
        <Select
          value={selectedProduct}
          label="Product"
          onChange={(e) => setProduct(e.target.value as Product)}
        >
          <MenuItem value={Product.IM_MATH}>IM Math</MenuItem>
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>Experiment Version</InputLabel>
        <Select
          value={selectedExperiment}
          label="Experiment Version"
          onChange={(e) => setExperiment(e.target.value as ExperimentVersion)}
        >
          <MenuItem value={ExperimentVersion.V0_0_0}>v0.0.0</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
